export const MAIN_CLASS_NAME = 'project-fragment-list';
